import { Box } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Fragment } from 'react';

import colors from '/@/components/theme-provider/colors';

const CornDensityChartTable = ({ products }) => {
    return (
        <Box>
            {products.map((p) => (
                <Table sx={{ minWidth: 650 }}>
                    <TableBody>
                        <Fragment>
                            <TableRow sx={{ backgroundColor: colors.gray[100] }}>
                                <TableCell rowSpan={3} align='center'>
                                    {p.label}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                {p.densityTableValues.map((value, i) => (
                                    <TableCell align='center'>{value.environment}</TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                {p.densityTableValues.map(({ value: { value, unit } }, i) => (
                                    <TableCell align='center'>
                                        {value} {unit}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </Fragment>
                    </TableBody>
                </Table>
            ))}
        </Box>
    );
};

export default CornDensityChartTable;
